<template>
  <div class="container">
    <div class="content">
      <div class="logo"><img class="img" src="../../assets/u115.png" /></div>
      <div class="patient-box" @click="selectPatient">
        <div class="label">当前就诊人</div>
        <div class="text">
          {{ patient }}
          <van-icon name="arrow" size="16" color="#999" />
        </div>
      </div>
      <div class="doc-box">
        <div class="doc-item">
          <div class="doc-headimg">
            <img src="../../assets/doctor.png" class="img" alt="" srcset="" />
          </div>
          <div class="doc-detail">
            <div class="name">金辉</div>
            <div class="title">
              <div class="title-detail">科室发热门诊</div>
            </div>
          </div>
        </div>
        <div class="time-box">
          <div class="label">预约时间</div>
          <div class="text" @click="selectTime">
            {{ selectDate }}
            <van-icon name="arrow" size="16" color="#999" />
          </div>
        </div>
        <div class="text-box">
          <div>*线上开具核酸检测，仅限自费患者。</div>
          <div>*核酸检测时间为早8:00至16:00</div>
          <div>*请携带本人身份证或其他有效证件</div>
        </div>
      </div>
    </div>
    <div class="bun">
      <van-button color="#7bb8c8" size="large" @click="toConfirm"
        :disabled="selectDate == '请选择检测时间' || patient == '请选择就诊人'" :loading="refundLoading" :loading-type="'spinner'"
        loading-text="预约中...">
        确认预约
      </van-button>
    </div>
    <div class="bg"></div>

    <van-calendar v-model="show" :show-confirm="false" :min-date="minDate" :max-date="maxDate" @confirm="
    selectPickerDate" @cancel="cancelPicker" :default-date="defaultDate" />
  </div>
</template>

<script>
import { getDefaultPatient, reg } from '@/api/api'
import { Toast } from 'vant'
export default {
  data () {
    return {
      minDate: new Date(),
      maxDate: new Date(new Date(new Date().toDateString()).getTime() + 259200000),
      refundLoading: false,
      show: false,
      selectDate: '请选择检测时间',
      patient: '请选择就诊人',
      patientData: {},
      docData: {
        doctorName: '',
        doctorTitle: '',
      },
      sectionData: {},
      time: 5,
      timer: null,
      defaultDate: null,
      pcode: '', //病案号
      people: {},
    }
  },
  created () {
    console.log(this.minDate, this.maxDate)
  },
  mounted () {
    if (this.$route.query.patientName) {
      this.patientData = {
        patientName: this.$route.query.patientName,
        patientId: this.$route.query.patientId,
        phoneNumber: this.$route.query.phoneNumber,
      }
      this.patient = this.$route.query.patientName
    } else {
      this.getPatientData()
      this.timer = setInterval(() => {
        this.countNum()
      }, 1000)
    }
    // 获取默认时间
    let now = new Date()
    if (now.getHours() >= 16) {
      now.setDate(now.getDate() + 1)
      this.defaultDate = now
      this.selectDate = this.getStrDate(now)
    } else {
      this.defaultDate = now
      this.selectDate = this.getStrDate(now)
    }
  },
  methods: {
    getStrDate (date) {
      let dateObj = new Date(date)
      return (
        dateObj.getFullYear() +
        '/' +
        (dateObj.getMonth() + 1) +
        '/' +
        dateObj.getDate()
      )
    },
    countNum () {
      this.time -= 1
      if (this.time == 0) {
        window.clearInterval(this.timer)
      }
    },
    cancelPicker () {
      this.show = false
    },
    getPatientData () {
      getDefaultPatient().then((res) => {
        if (res.code == 200) {
          if (res.data.length != 1) {
            this.patient = '无'
          } else {
            this.patient = res.data[0].patientName
            this.pcode = res.data[0].patientIdCard
            this.people = res.data[0]
          }
        }
      })
    },
    // 就诊人管理
    selectPatient () {
      this.$router.push('patientList')
    },
    toConfirm () {
      this.refundLoading = true;
      let value = sessionStorage.getItem("type");
      let type = value == 3 ? 2 : 1 // 1单检   2混检
      reg(this.pcode, type).then((res) => {
        if (res.code == 200) {
          this.refundLoading = false;
          let parseData = JSON.parse(res.data)
          parseData[0]['time'] = this.selectDate //就诊时间
          parseData[0]['phone'] = this.people.phoneNumber //就诊人手机号
          parseData[0]['name'] = this.people.patientName //就诊人姓名
          parseData[0]['idcode'] = this.people.idCard //就诊人身份证号码
          parseData[0]['patientId'] = this.people.patientId //就诊人id

          // acidpay

          this.$router.push({
            name: 'questionnaire',
            query: {
              data: parseData[0],
            },
          })
        } else {
          this.refundLoading = false;
          Toast(res.msg)
        }
      }).catch(() => {
        this.refundLoading = false;
      })
    },
    selectTime () {
      this.show = true
    },
    selectPickerDate (v) {
      this.selectDate =
        v.getFullYear() + '/' + (v.getMonth() + 1) + '/' + v.getDate()
      this.show = false
    },
  },
}
</script>

<style scoped lang="scss">
.container {
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  background-color: rgb(244, 248, 251);

  .content {
    width: 100%;
    height: 100%;
    z-index: 1;
    padding: 0 15px;
    font-size: 16px;
    position: relative;

    .logo {
      width: 100%;
      height: 148px;
      display: flex;
      justify-content: center;

      .img {
        width: 148px;
        height: 148px;
      }
    }

    .patient-box {
      width: 100%;
      background: #fff;
      padding: 10px 15px;
      display: flex;
      justify-content: space-between;

      .label {
        color: #2c2aff;
      }

      .text {
        color: #999;
        display: flex;
        align-items: center;
      }
    }

    .doc-box {
      width: 100%;
      background: #fff;
      display: flex;
      flex-direction: column;
      border-radius: 20px;
      margin-top: 20px;

      .doc-item {
        width: 100%;
        border-bottom: 1px solid rgba(228, 228, 228, 1);
        display: flex;
        align-items: center;
        padding: 10px 10px;

        .doc-headimg {
          width: 70px;
          height: 70px;

          .img {
            width: 100%;
            height: 100%;
          }
        }

        .doc-detail {
          height: 50px;
          padding-left: 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .name {
            width: 100%;
          }

          .title {
            width: 100%;

            .title-detail {
              border: 1px solid rgba(68, 203, 255, 1);
              color: #44cbff;
              font-size: 12px;
              padding: 2px 10px;
              border-radius: 3px;
              text-align: center;
            }
          }
        }
      }

      .time-box {
        width: 100%;
        display: flex;
        padding: 20px 15px;
        justify-content: space-between;
        border-bottom: 1px solid rgba(228, 228, 228, 1);

        .label {
          color: #2c2aff;
        }

        .text {
          color: #999;
          display: flex;
          align-items: center;
        }
      }

      .text-box {
        color: red;
        padding: 20px 15px;
        line-height: 30px;
      }
    }
  }
}

.bg {
  width: 100%;
  height: 55vh;
  position: fixed;
  z-index: 0;
  top: -50px;
  background: rgb(123, 184, 187);
  border-radius: 50px;
}

.bun {
  margin-top: 30px;
  padding: 0 20px;
}
</style>
